import { z } from 'zod';

export enum SchoolRank {
  Unknown = 0,
  Primary = 1,
  PrimaryJunior = 6,
  Junior = 7,
  JuniorSenior = 8,
  Senior = 10,
  Senior4 = 11,
}
export const schoolRankZod = z.nativeEnum(SchoolRank);

export enum SchoolClassNameEnum {
  Regular = 0,
  JiaYiBingDing = 1,
  ZhongXiaoRenAi = 2,
  MeiLanZhuJu = 3,
  WenLiangKungChien = 4,
}
export const SchoolClassNameEnumZod = z.nativeEnum(SchoolClassNameEnum);

export const schoolZod = z.object({
  id: z.string(),
  name: z.string(),
  tel: z.string(),
  zip: z.string(),
  address: z.string(),
  rank: z.number().int(),
  grade: z.string().nullish(),
  cityCode: z.string().nullish(),
  countryCode: z.string(),
  currentSchoolYear: z.number().int().nullish(),
});

export const simpleSchoolZod = z.object({
  id: z.string(),
  name: z.string(),
  rank: schoolRankZod,
});

export const schoolInfoZod = z.object({
  moeSchoolID: z.string(),
  schoolName: z.string(),
  areaID: z.number().int(),
  suid: z.number().int(),
  etid: z.number().int(),
  stid: z.number().int(),
  srid: z.number().int().nullish(),
  address: z.string().nullish(),
  url: z.string(),
  tel: z.string(),
  postalCode: z.number().int(),
  unitClassID: z.number().int(),
  sameUnitId: z.number().int().nullish(),
});

export type School = z.infer<typeof schoolZod>;
export type SimpleSchool = z.infer<typeof simpleSchoolZod>;
export type SchoolInfo = z.infer<typeof schoolInfoZod>;
